import { ReactNode } from "react";
import {
  ISpacing,
  ITextTransform,
  IFontWeight,
  IFontSize,
  ITextColor,
  ITextAlign,
  IOpacity,
  IVisibility,
  ITransition,
  IPointer,
  ITextDecoration,
} from "../../styled-components/interface";
import { styled, css } from "../../styled-components";
import {
  TextTransform,
  FontSize,
  FontWeight,
  Color,
  TextAlign,
  Opacity,
  Visibility,
  Transition,
  Pointer,
  TextDecoration,
} from "../styles";

interface ITextProps
  extends ISpacing,
    ITransition,
    ITextTransform,
    IFontWeight,
    IFontSize,
    ITextColor,
    ITextAlign,
    IOpacity,
    IVisibility,
    ITextDecoration,
    IPointer {
  children?: ReactNode;
  className?: string;
}

const TextStyles = css`
  ${TextAlign};
  ${TextTransform};
  ${FontWeight};
  ${FontSize};
  ${Color};
  ${Opacity};
  ${Visibility};
  ${Transition};
  ${Pointer};
  ${TextDecoration};
`;

const Text = styled.div<ITextProps>`
  ${TextStyles};
`;

export { Text, ITextProps, TextStyles };
